module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, _vm._l((_vm.guests), function(guest) {
    return _c('article', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h5', {
      staticStyle: {
        "color": "#008000"
      }
    }, [_vm._v(_vm._s(guest.event.name) + "(" + _vm._s(guest.sale.ticket.name) + ")")]), _vm._v(" "), (_vm.isBuyer(guest)) ? _c('button', {
      staticClass: "delete is-large deletebtn",
      on: {
        "click": function($event) {
          return _vm.deleteTicket(guest)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.statusReturn(guest.status))), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Participante: ")]), _vm._v(_vm._s(guest.person.name)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Documento: ")]), _vm._v(_vm._s(guest.person.document)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email: ")]), _vm._v(_vm._s(guest.person.email)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Telefone: ")]), _vm._v(_vm._s(guest.person.phone) + "\n      ")])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ec07b11!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Tickets.vue
// module id = 101
// module chunks = 2